import gql from 'graphql-tag';
import fragments from '../fragments';

export default {
    createClassTypeMutation: gql`
        mutation CreateClassType($campaignID: String!, $classTypeName: String!, $context: String, $epsilon: Float!, $type: String!) {
            createClassType(campaignID: $campaignID, classTypeName: $classTypeName, context: $context, epsilon: $epsilon, type: $type) {
                id
            }
        }
    `,
};
